import type { PurgeRun, PurgeRunStatus } from '@restaurant/api-contracts';

export function skippedOf(run: PurgeRun): { reason: string; count: number }[] {
  return Object.entries(run.breakdown?.skipped ?? {})
    .filter(([, count]) => count > 0)
    .map(([reason, count]) => ({ reason, count }));
}

export const RUN_STATUS_COLOR: Record<PurgeRunStatus, string> = {
  RUNNING: '#8e8e93',
  COMPLETED: '#34c759',
  PARTIAL: '#ff9500',
  FAILED: '#ff3b30',
};

export function newestFirst(runs: PurgeRun[]): PurgeRun[] {
  return [...runs].sort(
    (a, b) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime(),
  );
}

export function skipReasonLabel(table: Record<string, string>, reason: string): string {
  return table[reason] ?? reason;
}
